module.exports = __webpack_public_path__ + "img/request-panel.png";